import { Box } from '../../Box/Box.js';
import styled, { keyframes, css } from 'styled-components';

var ripple = /*#__PURE__*/keyframes({
  '0%': {
    transform: 'translate(-50%, -50%) scale(0)',
    opacity: 0.8
  },
  '60%': {
    transform: 'translate(-50%, -50%) scale(1)'
  },
  '100%': {
    transform: 'translate(-50%, -50%) scale(1)',
    opacity: 0
  }
});
var RippleStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Ripplestyled__RippleStyled",
  componentId: "sc-56mfwd-0"
})({
  opacity: 0,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%) scale(0)',
  borderRadius: '100%',
  transition: 'opacity 0.5s, transform 0.3s'
}, css(["animation:", " ", "s;"], ripple, function (props) {
  return props.$duration;
}));

export { RippleStyled };
//# sourceMappingURL=Ripple.styled.js.map
